import React from "react";
import excel from "../../images/excel.png";
import DebitLoadList from "./DebitLoadList.js";
import PaymentReportPagination, { PaymentReportHeaderRow } from "./PaymentReportPagination";
import usePaymentReport from "./usePaymentReport";
import usePaymentPagination from "./usePaymentPagination";
import { buildPaymentRows, downloadPaymentXlsx } from "./paymentExcel";

export default function DebitLoadStatus(props) {
    const data = usePaymentReport("debit", props);
    const { offset, limit, page, itemsPerPage, setitems, pageBack, pageForward } = usePaymentPagination(data);

    function handleDownloadClick() {
        const rows = buildPaymentRows(data, {
            idLabel: "Debit Confirmation",
            getIdCell: () => "",
            // NOTE: pre-existing quirk - data rows carry one more cell than the
            // header row, leaving an unlabelled empty trailing column.
            trailingCells: [""],
        });
        downloadPaymentXlsx(rows, "Debit Load Status", "DebitLoadStatus");
    }

    return (
        <div className="clear">
            <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="clear">
                    <div className="border-color">
                        <strong>
                            <span className="underline">Debit Load Status:</span>
                        </strong>
                        <strong>Paid:</strong> Funds have been loaded to the card
                    </div>
                </div>
                <span className="tooltip" style={{ float: "right" }}>
                    <a onClick={handleDownloadClick}>
                        <img src={excel} className="excel" />
                    </a>
                    <span className="tooltiptext">
                        Click here to download entire patient list. Please note there is a 24 hour delay for newly enrolled patients to be
                        included in this excel list
                    </span>
                </span>
                <table style={{ marginTop: "0", marginBottom: "0" }} className="account">
                    <thead>
                        <PaymentReportHeaderRow idLabel="Debit Confirmation" />
                    </thead>
                    <DebitLoadList data={data} page={page} items={itemsPerPage} offset={offset} limit={limit} />
                </table>
                <PaymentReportPagination
                    data={data}
                    offset={offset}
                    limit={limit}
                    setitems={setitems}
                    pageBack={pageBack}
                    pageForward={pageForward}
                />
            </div>
        </div>
    );
}


